
import { Vue, Options } from 'vue-class-component'
import SvgBase from './SvgBase.vue'
import { Prop } from 'vue-property-decorator'

@Options({
  components: {
    SvgBase,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
  },
})
export default class IconSwitch extends Vue {
  @Prop({ type: String }) readonly color?: string = 'white'
}
